import React, { Component } from 'react';

// Components
import { PageSection } from '../PageSection';
import { PaddedBox } from '../generic/PaddedBox';
import { SectionTitle } from '../generic/SectionTitle';
import { SectionText } from '../generic/SectionText';

import { SolutionInfo } from './Solution/SolutionInfo';

export class Solution extends Component {
    render() {
        return (
            <PageSection sectionId="solution">
                <img src="./images/generic/bg-icon-waves.png" alt="" style={{ position: 'absolute', top: '-20px', left: '-20px', zIndex: -1 }} />
                <img src="./images/generic/bg-icon-heart.png" alt="" style={{ position: 'absolute', top: '180px', right: '-20px', zIndex: -1 }} />

                <PaddedBox>
                    <SectionTitle>The Solution</SectionTitle>
                    <SectionText>
                        <p>
                            We developed a mobile app called ‘Plant Life Balance’ that featured the use of augmented reality,
                            for both android and iOS platforms. Our responsibilities included UX and UI, technical design,
                            interactivity/gamification and algorithm development.
                        </p>

                        By taking a photo of your own space, the app allowed people to:
                    </SectionText>
                </PaddedBox>

                <SolutionInfo />

                {this.props.children}
            </PageSection>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/sections/Solution.jsx